/* eslint-disable import/prefer-default-export */

import axios from './axios';

export const getServiceTypes = ({ params } = {}) => axios.get(`service_types`, { params });